import React from 'react';
import { ButtonColor, ButtonVariant, IconButton } from 'react-magma-dom';
import { CloseModalIcon } from '../../assets/icons/ImageEditTool';
import { StyledResetModalWindow, StyledTextWrapper } from '../Styled/StyledModal';
import { IModal } from './ModalWindow';
import { StyledResetButton } from '../Styled/StyledButtons';
import { COLORS } from '../../constants';

export const ResetModal = (props: IModal): JSX.Element => {
  const { showModal, setShowModal, mainColor, onConfirm } = props;

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <StyledResetModalWindow isOpen={showModal} isCloseButtonHidden onClose={handleClose}>
      <IconButton
        testId="reset-modal-close"
        aria-label="Close default images modal window"
        color={ButtonColor.secondary}
        variant={ButtonVariant.link}
        icon={<CloseModalIcon />}
        onClick={handleClose}
      />
      <StyledTextWrapper>
        <span>Are you sure you want to reset?</span>
        <span>The exemplar will return to its original state.</span>
      </StyledTextWrapper>
      <StyledResetButton data-testid="modal-button" onClick={onConfirm} color={mainColor || COLORS.cadmiumViolet}>
        <span>Reset</span>
      </StyledResetButton>
    </StyledResetModalWindow>
  );
};
